import firebase from "../../firebase";
import { getAuth } from "firebase/auth";

const auth = getAuth(); // Create a singleton instance of the Firebase authentication object
export default auth;
